export const emojiMap = {
  ":)": "/assets/emoticons/smile.png",
  ";)": "/assets/emoticons/wink.png",
  ":P": "/assets/emoticons/tongue.png",
  "(y)": "/assets/emoticons/like.png",
  "(n)": "/assets/emoticons/dislike.png",
  "<3": "/assets/emoticons/heart.png",
  "</3": "/assets/emoticons/brokenHeart.gif",
  ":'(": "/assets/emoticons/sad.png",
  ";'(":  "/assets/emoticons/cry.png",
  "|-)": "/assets/emoticons/bored.png",
  "B)": "/assets/emoticons/cool.png",
  "<:o": "/assets/emoticons/party.png",
  ">:(": "/assets/emoticons/angry.png",
  "^o)": "/assets/emoticons/sarcastic.png",
  ":D": "/assets/emoticons/grin.png",
  "*-)": "/assets/emoticons/eyeroll.png",
  ":S": "/assets/emoticons/confused.png",
  ":-O": "/assets/emoticons/suprised.png",
  "(C)": "/assets/emoticons/freezing.png",
  "+o(":"/assets/emoticons/sick.png",
  "(6)": "/assets/emoticons/devil.png",

  "(K)": "/assets/emoticons/kiss.png",
  "(Li)": "/assets/emoticons/lightning.gif",



};